import { render } from "./TableTitheCommitment.vue?vue&type=template&id=70d1f148"
import script from "./TableTitheCommitment.vue?vue&type=script&lang=js"
export * from "./TableTitheCommitment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__